export function escapeODataString(value) {
    // Double apostrophes for OData compliance
    return value.replace(/'/g, "''");
}

export function escapeEncode(value) {
    const safeName = escapeODataString(value);
    return encodeURIComponent(safeName);
}
